// External
import { createSlice } from "@reduxjs/toolkit";

// Action Constants
import { changeNavigation } from "../actions/navigation";

// Initial State
const initialState = {
	currentQuestion: "1",
	theme: { foreground: "theme1_foreground" },
	surveyStep: 1,
};
// Answer Reducer
const navigation = createSlice({
	name: "navigation",
	initialState,
	reducers: {},
	extraReducers: {
		// Used with external action which is defined in other directory
		[changeNavigation.type]: (state, action) => {
			const { currentQuestion, surveyStep } = action.payload;

			state.currentQuestion = currentQuestion;

			state.surveyStep = surveyStep;

			return state;
		},
	},
});
export default navigation.reducer;
